var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleQuestionRegular(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_192_421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5909 0C6.97937 0 0 6.69679 0 14.9597C0 23.2226 6.97937 29.9193 15.5909 29.9193C24.2024 29.9193 31.1818 23.2226 31.1818 14.9597C31.1818 6.69679 24.2024 0 15.5909 0ZM15.5909 27.1144C8.60545 27.1144 2.92329 21.6617 2.92329 14.9597C2.92329 8.25762 8.60545 2.80494 15.5909 2.80494C22.5764 2.80494 28.2585 8.25762 28.2585 14.9597C28.2585 21.6617 22.5764 27.1144 15.5909 27.1144ZM15.5909 19.6346C14.4947 19.6346 13.642 20.4527 13.642 21.5045C13.642 22.5564 14.4399 23.3745 15.5909 23.3745C16.6323 23.3745 17.5398 22.5564 17.5398 21.5045C17.5398 20.4527 16.6323 19.6346 15.5909 19.6346ZM17.6068 7.47984H14.4947C12.1195 7.47984 10.2315 9.29136 10.2315 11.5704C10.2315 12.33 10.9015 12.9728 11.6932 12.9728C12.4849 12.9728 13.1548 12.33 13.1548 11.5704C13.1548 10.8691 13.709 10.2848 14.4399 10.2848H17.5519C18.3376 10.2848 19.0014 10.8691 19.0014 11.5704C19.0014 12.0379 18.7578 12.3943 18.3315 12.6281L14.8601 14.6675C14.3729 14.9597 14.1293 15.4272 14.1293 15.8947V16.8296C14.1293 17.5893 14.7992 18.2321 15.5909 18.2321C16.3826 18.2321 17.0525 17.5893 17.0525 16.8296V16.7128L19.7992 15.0765C21.0782 14.3169 21.8699 12.9728 21.8699 11.5704C21.9247 9.29136 20.0367 7.47984 17.6068 7.47984Z",
    fill: "#FBC2B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_192_421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.1818,
    height: 29.9193,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleQuestionRegular);
export default __webpack_public_path__ + "static/media/circle-question-regular.69c3bdf8b01376ee8b96767a2cea0182.svg";
export { ForwardRef as ReactComponent };